import { createFileRoute } from "@tanstack/react-router";
import AdminPackagePreview from "@/pages/AdminPackagePreview";

export const Route = createFileRoute("/admin/accelerator/startup/$id/package/")({
  component: AdminPackagePreview,
});
